export default __webpack_public_path__ + "static/media/Banner_Ronaldo2.1be1bd7d.png";